import { Col, Container, Row, Stack } from 'react-bootstrap'
import React, { useState } from 'react'
import { OAuth2AppsButtonManager } from './OAuth2AppsButtonManager'
import { OAuth2App } from '../../../../store/auth/auth'
import './OAuth2AppsRow.scss'
import { OAuth2AppsModalManager, OAuth2AppsModalType } from '../Modals/OAuth2AppsModalManager'

interface OAuth2AppsRowProps {
  oAuth2App: OAuth2App
}

export const OAuth2AppsRow: React.FC<OAuth2AppsRowProps> = ({ oAuth2App }) => {
  const { name, imageUrl, shortDescription } = oAuth2App

  const initials = name.slice(0, 2).toUpperCase() || '?'

  const [activeModal, setActiveModal] = useState<OAuth2AppsModalType>(null)

  return (
    <Container fluid>
      <OAuth2AppsModalManager oAuth2App={oAuth2App} activeModal={activeModal} onClose={() => setActiveModal(null)} />
      <Row className='d-flex justify-content-between align-items-center'>
        <Col>
          <Stack direction='horizontal' className='gap-4 align-items-center'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100 align-self-start app-logo-background'>
              {imageUrl ? (
                <img src={imageUrl} alt={`${name} logo`} className='oauth-app-icon' />
              ) : (
                <span className='oauth-app-icon app-icon-initials'>{initials}</span>
              )}
            </div>
            <div className='h-auto'>
              <div className='app-row-name'>{name}</div>
              <div className='zocks-text-gray-600'>{shortDescription}</div>
            </div>
          </Stack>
        </Col>

        <Col xs='auto'>
          <OAuth2AppsButtonManager oAuth2App={oAuth2App} hideManageButton={true} onRequestModal={(modal) => setActiveModal(modal)} />
        </Col>
      </Row>
    </Container>
  )
}
